import Logo from "../../components/icons/Logo";
import Tap from "../../assets/img/Green-Touch-Icon.gif";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../components/Header";
import DiningHall from "../../components/icons/NavIcons/DiningHall";
import Kitchen from "../../components/icons/NavIcons/Kitchen";
import FoodCourt from "../../components/icons/NavIcons/FoodCourt";

const CampusDining = () => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent, location])
    return (
      <div className="page splash campusDiningPage">
        <Header />
        <div className="page-header">Campus Dining</div>
        <div className="text-blocks">
          <div className="std-text">
            Use InfoGenesis Meal Plan Integration to 
            offer your students the convenience of 
            cashless tender.{'\n\n'}

            Establish multiple types of Meal Plan 
            accounts for students and faculty through 
            student cards, payroll deductions, stored 
            value and VIP cards.
          </div>
        </div>
        <div
          className="logo"
          onClick={() => {
            _logEvent("click", "Campus Dining", "Agilysys");
            addFlow("Agilysys");
            navigate("/aboutus/agilysys");
          }}
        >
          <Logo />
        </div>
        <div className="campus-dining-map">
          <div className="dining-hall">
            <DiningHall
              onClick={() => {
                _logEvent("click", "Campus Dining", "Dining Hall");
                addFlow("Dining Hall");
                navigate("dining-hall", { relative: "path" });
              }}
            />
          </div>
          <div className="kitchen">
            <Kitchen
              onClick={() => {
                _logEvent("click", "Campus Dining", "Kitchen");
                addFlow("Kitchen");
                navigate("kitchen", { relative: "path" });
              }}
            />
          </div>
          <div className="food-court">
            <FoodCourt
              onClick={() => {
                _logEvent("click", "Campus Dining", "Food Court");
                addFlow("Food Court");
                navigate("food-court", { relative: "path" });
              }}
            />
          </div>
        </div>
        <div className="tap">
          <img src={Tap} alt="" />
          <div className="tap-prompt">
            Tap on each section of the map{"\n"}
            To drill into the details
          </div>
        </div>
      </div>
    );
}

export default CampusDining;